import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';

import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { QueryVal } from 'Helpers/Query';

import DataContainer from 'Components/UI/DataContainer';
import ScheduledMessagesList from './ScheduledMessagesList';

const styles = () => ({
  root: {},
});

const ScheduledMessages = ({
  classes,
  closeModal,
  ...rest
}) => {
  // Loading states
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);

  // Scheduled Messages states
  const [scheduledMessages, setScheduledMessages] = useState(null);
  const eventTrackingLogEventProps = useEventTrackingLogEvent({ nodeName: 'All Scheduled Messages View' });

  // Fetch scheduled messaged via link
  const scheduledMessagesSelfLink = QueryVal('scheduledMessagesSelfLink');
  const fetchScheduledMessages = async () => {
    try {
      setLoading(true);
      const scheduledMessagesCollection = await fr.http.get(scheduledMessagesSelfLink);
      setScheduledMessages(scheduledMessagesCollection);
    } catch (err) {
      setLoadingError(true);
      displayErrorMessage('Error fetching scheduled messages', err);
    } finally {
      setLoading(false);
    }
  };

  // ReFetch scheduled messages via collection
  const refreshScheduledMessages = async () => {
    if (!scheduledMessages) return;
    try {
      setLoading(true);
      const coll = await scheduledMessages.refresh();
      setScheduledMessages(coll);
      setLoading(false);
    } catch (err) {
      setLoadingError(true);
      displayErrorMessage('Error refreshing scheduled messages', err);
    }
  };

  // Fetch scheduled messages on mount
  useEffect(() => {
    fetchScheduledMessages();
  }, [scheduledMessagesSelfLink]);

  const { rootNodeProps } = eventTrackingLogEventProps;

  return (
    <DataContainer
      loading={loading}
      loadingError={loadingError}
      {...rootNodeProps}
    >
      <ScheduledMessagesList
        scheduledMessages={scheduledMessages}
        refreshScheduledMessages={refreshScheduledMessages}
        eventTrackingLogEventProps={eventTrackingLogEventProps}
        {...rest}
      />
    </DataContainer>
  );
};

ScheduledMessages.defaultProps = {
  className: '',
};

ScheduledMessages.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ScheduledMessages);
